<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  name: string
}

const props = defineProps<Props>()

const formattedParts = computed(() => {
  const pattern = /(pharmacy(\s|$)|drug\s*mart|drugmart|#\d+|#\s+\d+|the\s+|No\.\s+\d+)/gi
  let lastIndex = 0
  const result: Array<{ text: string; subdued: boolean }> = []
  let match

  try {
    let loopCount = 0
    while ((match = pattern.exec(props.name)) !== null) {
      loopCount++
      if (loopCount > 10) {
        break
      }
      // Add text before the match (if any)
      if (match.index > lastIndex) {
        result.push({
          text: props.name.slice(lastIndex, match.index),
          subdued: false
        })
      }
      
      // Add the matched text
      result.push({
        text: match[0],
        subdued: true
      })
      
      lastIndex = match.index + match[0].length
    }
    
    // Add remaining text after last match (if any)
    if (lastIndex < props.name.length) {
      result.push({
        text: props.name.slice(lastIndex),
        subdued: false
      })
    }
  } catch (e) {
    // do nothing
  }
  
  // If no matches, return the whole name
  if (result.length === 0) {
    result.push({
      text: props.name,
      subdued: false
    })
  }
  
  return result
})
</script>

<template>
  <span>
    <template v-for="(part, index) in formattedParts" :key="index">
      <span v-if="part.subdued" class="opacity-60">{{ part.text }}</span>
      <template v-else>{{ part.text }}</template>
    </template>
  </span>
</template>